export default __webpack_public_path__ + "21d38cf216a7e28988614a53157fd5af.png";